import React, { useEffect, useState } from 'react';
import './Pop.css';

const PopupNotification = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 5000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  return (
    showPopup && (
      <div className="popup-overlay">
        <div className="popup-box">
          <button className="popup-close" onClick={handleClose}>×</button>
          <img src="logo7.jpg" alt="Tamilmanamalai Logo" className="popup-logo" />
          <h3>Tamilmanamalai Matrimony</h3>
          <p>Your trusted partner in finding the perfect match. Join us for a beautiful matrimonial journey.</p>
          <a href="https://www.tamilmanamalai.in/" target="_blank" rel="noopener noreferrer">
            <button className="popup-button">->Go to the Website</button>
          </a>
        </div>
      </div>
    )
  );
};

export default PopupNotification;
